import Config from '../config';

import { diffHash } from '../model/diff';
import { promisify } from "../utils/promisify";

export { save, restrict }





function restrict(roles, fn, handler) {
    if (typeof roles === 'function')
        handler = fn, fn = roles, roles = undefined;
    if (handler === undefined)
        handler = fn, fn = undefined;
    
    return {
        handler,

        disabled() {
            if (roles && !roles.includes( Config.role() ))
                return true;

            return fn ? !fn() : false;
        }
    };
}

function save(view) {
    const diff = view.diff();

    const pendingUploadDiff = diff
        .filter( ({ newValue }) => newValue instanceof File )
        .map( ({ newValue: file, attrName }) => 
            // wait for upload and then construct new diff item
            // with actual file name
            file.upload.then( fname => ({ attrName, newValue: fname }) ) );

    return Promise.all( pendingUploadDiff ).then( uploadDiff => {
        // combine changed attrs and uploaded files
        // into one single attrs hash
        const attrs = diffHash( [...diff, ...uploadDiff ] );

        // todo post через промежуточную модель
        // скорее всего наследие Task.save()
        // где мы отправляем на сервер один JSON, а 
        // получаем обратно совсем другой

        const model = new view.model.constructor( { id: view.model.id } );

        const options = { patch: model.id !== undefined };

        return promisify( model.save( attrs, options ) );
    } )//, failure => console.log( failure ) );
}



// WEBPACK FOOTER //
// ./src/js/model/actions.js